
















export default {
  name: 'PlusBoldIcon',
  props: {
    color: {
      type: String,
      default: '#000000'
    }
  }
}
